<script lang="ts">
</script>

<div class="mt-1 flex flex-row text-xs text-gray-600 dark:text-gray-400 justify-center items-center">
    <hr class="flex-1 ml-8" />
    <div class="px-2"><slot /></div>
    <hr class="flex-1 mr-8" />
</div>
